var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 8.50011C1 12.6357 4.36455 16.0002 8.50011 16.0002C12.6357 16.0002 16.0002 12.6357 16.0002 8.50011C16.0002 4.36455 12.6357 1 8.50011 1C4.36455 1 1 4.36455 1 8.50011Z",
    fill: "#1752AF",
    stroke: "#1752AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.49845 13.1219C8.16754 13.1219 7.89844 12.8528 7.89844 12.5219C7.89844 12.191 8.16754 11.9219 8.49845 11.9219C8.82935 11.9219 9.09846 12.191 9.09846 12.5219C9.09846 12.8528 8.82935 13.1219 8.49845 13.1219Z",
    fill: "#1752AF",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.20312 9.72663V5.52657C8.20312 5.36096 8.33723 5.22656 8.50313 5.22656C8.66903 5.22656 8.80313 5.36096 8.80313 5.52657V9.72663C8.80313 9.89223 8.66903 10.0266 8.50313 10.0266C8.33723 10.0266 8.20312 9.89223 8.20312 9.72663Z",
    fill: "#1752AF",
    stroke: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningBlue);
export default __webpack_public_path__ + "static/media/WarningBlue.e5eb9f4fe8fc24b32522f7af7d47bc2b.svg";
export { ForwardRef as ReactComponent };